<template>
    <section class="section">
        <div class="container">
            <div class="columns">
                <div class="column is-3">
                    <aside class="menu">
                        <div v-for="nav in myMenu" :key="nav.headline" style="margin-bottom: 1rem;">
                            <p class="menu-label">
                                {{ nav.headline }}
                            </p>
                            <ul class="menu-list" v-if="nav.items">
                                <li
                                    v-for="sub in nav.items"
                                    :key="sub.label"
                                    @click.prevent="onSelectMenu(sub)"
                                >
                                    <a :class="{ 'is-active': sub === activeComponent}">{{ sub.label }}</a>
                                </li>
                            </ul>
                        </div>
                    </aside>
                </div>
                <div class="column" v-if="activeComponent">
                    <component
                        :is="activeComponent.component"
                        :headline="activeComponent.label"
                        :tab="activeComponent.key"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import LocationSettings from './inventory/LocationSettings';
import Rates from './projects/Rates';
import DefaultDescriptions from './projects/DefaultDescriptions';

export default {
    name: "Company",
    components: {
        LocationSettings,
        DefaultDescriptions,
    },
    data() {
        return {
            menu: [
                {
                    headline: 'General',
                    items: [
                        {
                            label: "Satser",
                            component: Rates,
                            key: 'rates',
                            visible: this.$store.getters.user.role === 'admin',
                        },
                        {
                            label: "Standard beskrivelser",
                            component: DefaultDescriptions,
                            key: 'default-descriptions',
                            visible: true,
                        },
                    ]
                }
            ],
            activeComponent: null,
        }
    },
    computed: {
        myMenu() {
            return this.menu.map(section => ({
                ...section,
                items: section.items.filter(item => item.visible === true)
            }));
        }
    },
    watch: {
        $route(to, from) {
            let tab = to.query.tab
            if (tab) {
                this.activeComponent = this.myMenu[0].items.find(item => item.key === tab)
            }
        }
    },
    methods: {
        onSelectMenu(activeComponent) {
            this.$router.push({ query: { tab: activeComponent.key } })

            this.activeComponent = activeComponent;
        }
    },
    mounted() {
        let params = new URLSearchParams(window.location.search)
        let tab = params.get('tab')

        if (tab) {
            this.activeComponent = this.myMenu[0].items.find(item => item.key === tab)
        }

        if (!this.activeComponent) {
            this.activeComponent = this.myMenu[0].items[0]
        }

        this.$store.dispatch('loadLocales')
    }
}
</script>

<style scoped>

</style>
